/** Canvas link the stats card already renders as a button. */
const DUPLICATE_CLEANER_LINK = /\[[^\]]*\]\(ch:\/\/canvas\/duplicates\)/gi;

/** Trim duplicate-cleaner CTAs from agent prose when the stats card is showing. */
export const stripDuplicateCleanerLink = (content: string): string =>
  content
    .replace(DUPLICATE_CLEANER_LINK, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
